export const setItem = (key, value) => window.localStorage.setItem(key, value);

export const getItem = (key) => {
  const item = window.localStorage.getItem(key);

  return item && JSON.parse(item);
};

export const clear = () => window.localStorage.clear();
